"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const components_1 = require("@/common/components");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const [regionDialogOpen, setRegionDialogOpen] = (0, react_1.useState)(false);
    const closeDialog = () => setRegionDialogOpen(false);
    const selectedRegion = (0, react_redux_1.useSelector)((state) => state.roomData.delivery_region);
    const currentLang = (0, detect_utils_1.currentLanguage)();
    const countries = (0, functions_1.getCountryObj)(currentLang);
    const currentCountryObj = countries.find(obj => obj.value === selectedRegion);
    const currentCountryCode = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.value) || '';
    const currentCountryName = (currentCountryObj === null || currentCountryObj === void 0 ? void 0 : currentCountryObj.name) || '';
    const dispatch = (0, react_redux_1.useDispatch)();
    const onRegionSelect = (region) => {
        selectedRegion !== region && dispatch((0, roomCreateStore_1.setRoomDeliveryRegion)(region));
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DeliveryRegionWrapper, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, sx: { alignItems: 'center', columnGap: '8px', fontWeight: 'bold', fontSize: '15px' } }, { children: [t('P-으로 배송'), (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ disableRipple: true, onClick: () => setRegionDialogOpen(true) }, { children: [Boolean(currentCountryCode) && ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                                        position: 'relative',
                                        flexShrink: 0,
                                        display: 'flex',
                                        width: '20px',
                                        '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '2px' }),
                                    } }, { children: (0, jsx_runtime_1.jsx)("img", { css: {
                                            width: '100%',
                                            borderRadius: '2px',
                                        }, alt: currentCountryName, src: `https://flagcdn.com/w20/${currentCountryCode.toLowerCase()}.webp`, srcSet: `https://flagcdn.com/w40/${currentCountryCode.toLowerCase()}.webp 2x` }) }))), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "text_overflow body2 gray-80", css: { WebkitLineClamp: 1 } }, { children: currentCountryName })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { position: 'absolute', right: '8px', width: '24px', height: '24px' } })] })), t('S-으로 배송')] })) }), (0, jsx_runtime_1.jsx)(components_1.RegionSelectDialog, { open: regionDialogOpen, closeDialog: closeDialog, countries: countries, selectedRegion: selectedRegion, onRegionSelect: onRegionSelect, titleText: t('작품을 어디로 배송하시나요?'), guideTextEl: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('구매자의'), (0, jsx_runtime_1.jsx)("span", { children: currentCountryName }), t('주소로 보냅니다.')] }) })] }));
}
exports.default = default_1;
const DeliveryRegionWrapper = styled_1.default.div `
  padding: 36px 20px 40px;
  background-color: white;
  button {
    justify-content: flex-start;
    column-gap: 10px;
    width: 66%;
    height: 40px;
    padding: 0 42px 0 11px;
    border: 1px solid var(--gray-10);
    border-radius: 6px;
    background-color: var(--white) !important;
  }
`;
